
const isString = (str) => {
    if(typeof str === 'string' && (Object.prototype.toString.call(str) === '[object String]')){
        return true
    } else {
        return false
    }
};

export default isString